<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col lg="6"> Anulir Presensi </v-col>
        <v-col lg="6" align="right">
          <v-btn
            dark
            color="blue"
            @click="
              req = {};
              modal.create = true;
            "
          >
            <v-icon>mdi-plus</v-icon>
            Tambah
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-text-field
          label="Search"
          v-model="filter.search"
          @change="
            () => {
              options.page = filter.page = 1;
              get();
            }
          "
          append-icon="mdi-magnify"
        ></v-text-field>
      </form>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="[
          {
            text: 'Tanggal',
            value: 'tanggal',
          },
          {
            text: 'NIS',
            value: 'siswa.nis',
          },
          {
            text: 'Nama',
            value: 'siswa.nama',
          },
          {
            text: 'Rombel',
            value: 'siswa_rombel',
          },
          {
            text: 'Keterangan',
            value: 'keterangan',
          },
          {
            text: 'File Pendukung',
            value: 'file',
          },
          {
            text: 'Opsi',
            value: 'actions',
          },
        ]"
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.siswa_rombel" slot-scope="{ item }">
          {{ item.siswa ? item.siswa.rombel.rombel : "" }}
        </template>

        <template slot="item.file" slot-scope="{ item }">
          <v-btn
            small
            text
            color="blue"
            role="a"
            :href="item.url_file"
            target="_blank"
            >Lihat</v-btn
          >
        </template>

        <template slot="item.actions" slot-scope="{ item }">
          <v-btn
            icon
            color="red"
            @click="
              req = item;
              modal.delete = true;
            "
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="modal.create">
      <v-form ref="create" @submit.prevent="store">
        <v-card width="500">
          <v-card-title>Tambah Anulir Presensi</v-card-title>
          <v-card-text>
            <v-alert
              dense
              v-show="is.submit"
              text
              icon="mdi-clock-fast"
              border="left"
              color="blue"
              >Menunggu...</v-alert
            >
            <v-autocomplete
              v-model="filter_siswa.rombel_id"
              @change="getSiswa"
              :items="data.rombel"
              label="Rombel"
              :rules="[(v) => !!v || 'rombel harus dipilih']"
            ></v-autocomplete>
            <v-autocomplete
              :disabled="!!!filter_siswa.rombel_id"
              v-model="req.siswa_id"
              :items="data.siswa"
              label="Siswa"
              :rules="[(v) => !!v || 'siswa harus dipilih']"
            ></v-autocomplete>
            <v-textarea
              rows="3"
              v-model="req.keterangan"
              placeholder="Masukkan Keterangan"
              label="Keterangan"
              :rules="[(v) => !!v || 'keterangan harus diisi']"
            ></v-textarea>
            <v-file-input
              @change="handleFile"
              counter
              show-size
              placeholder="Pilih File Pendukung"
              label="File Pendukung"
              :rules="[(v) => !!v || 'file pendukung harus ada']"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
            <v-btn type="button" text color="red" @click="modal.create = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="modal.delete">
      <v-card width="450">
        <v-form @submit.prevent="destroy">
          <v-card-title>Hapus Anulir Presensi</v-card-title>
          <v-card-text>Anda yakin menghapus data terpilih?</v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Hapus</v-btn>
            <v-btn type="button" text color="red" @click="modal.delete = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      modal: {
        create: false,
        edit: false,
        delete: false,
      },
      req: {},
      is: {
        loading: true,
        submit: false,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
      data: {
        siswa: [],
        rombel: [],
      },
      filter_siswa: {
        status: 'aktif',
      },
      tahun_ajaran_id: 0,
    };
  },
  created() {
    this.get();
    this.getData();
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  methods: {
    getData() {
      this.data.rombel = [];
      this.$root.app.http.get("/api/rombel").then((res) => {
        res.data.forEach((item) => {
          this.data.rombel.push({
            value: item.id,
            text: item.rombel,
          });
        });
      });

      this.$root.app.http.get("/api/tahunajaran").then((res) => {
        res.data.forEach((item) => {
          if (item.status == "aktif") {
            this.tahun_ajaran_id = item.id;
          }
        });
      });
    },
    getSiswa() {
      this.data.siswa = [];
      this.$root.app.http.get("/api/siswa", this.filter_siswa).then((res) => {
        res.data.forEach((item) => {
          this.data.siswa.push({
            value: item.id,
            text: item.nis + " - " + item.nama,
          });
        });
      });
    },
    get() {
      this.req = {};
      this.is.loading = true;
      this.$root.app.http.get("/api/siswa/anulir", this.filter).then((res) => {
        this.datas = res.data;
        this.recordsTotal = res.recordsTotal;
        this.is.loading = false;
      });
    },
    store() {
      this.is.submit = true;
      if (this.$refs.create.validate()) {
        this.req.tahun_ajaran_id = this.tahun_ajaran_id;
        this.$root.app.http.post("/api/siswa/anulir", this.req).then((res) => {
          this.is.submit = false;
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.create = false;
            this.$root.app.notif(res.message);
          }
        });
      }
    },
    destroy() {
      this.$root.app.http
        .del("/api/siswa/anulir/" + this.req.id)
        .then((res) => {
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.delete = false;
            this.$root.app.notif(res.message);
          }
        });
    },
    handleFile(e) {
      this.req.tipe_file = e.type;
      console.log(this.req.tipe_file);
      this.$root.app.toBase64(e, (result) => {
        this.req.file = result;
      });
    },
  },
};
</script>
